import useUser from '../contexts/hooks/useUser'
import { trpc } from '../modules/trpc'

export const useAchievementRefresh = () => {
	const { user } = useUser()

	const utils = trpc.useContext()

	const refreshAchievements = async () => {
		if (!user?.id) return

		await Promise.all([
			utils.achievements.getUserAchievements.invalidate(user.id),
			utils.achievements.getUserCurrentLevel.invalidate({ userId: user.id }),
			utils.achievements.getUserTotalPoints.invalidate({ userId: user.id }),
			utils.achievements.getUserPercentage.invalidate({ userId: user.id }),
			utils.achievements.getUserTotalSavings.invalidate({ userId: user.id }),
			utils.achievements.getUserCurrentSavings.invalidate({ userId: user.id }),
		])
	}

	return {
		refreshAchievements,
	}
}
